import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { CustomTable } from '../../components'
import { formatingHeaders } from '../../redux/helpers';

export const TableUserDetails = ({ grupo, nameUser, matricula, Fecha_y_hora }) => {
    const { arrayData } = useSelector((state) => state.table);
    const { typeAdmin } = useSelector((state) => state.auth)
    const { proyectSelected } = useSelector((state) => state.vrtSlice);

    const { responses } = useSelector((state) => {
        if (typeAdmin === "VRT") {
            return state.vrtSlice
        }
        else {
            return state.vrlSlice
        }
    });

    const [headers, setHeaders] = useState()
    const [dataFilterPerUser, setFileterData] = useState()

    useEffect(() => {
        const headerss = formatingHeaders(responses).filter(header => header.dataIndex !== "Detalles")
        setHeaders(headerss)
        if (typeAdmin === "VRT" && proyectSelected === "66fafd1d92bbc20883798c43") {
            // solo para pporyecto CEMEx filtrar por fecha
            setFileterData(arrayData.filter(data => {
                const dataDate = new Date(data.Fecha_y_hora).toDateString();
                const compareDate = new Date(Fecha_y_hora).toDateString();
                return data.Nombre === nameUser && dataDate === compareDate;
            }));
        }
        else {
            setFileterData(arrayData.filter(data => data.Nombre === nameUser))
        }
    }, [responses, proyectSelected, arrayData, Fecha_y_hora, typeAdmin, nameUser])


    return (
        <div className='w-full h-full flex flex-col px-4 py-4'>
            <div className='w-full h-5/12 flex'>
                <InfoUser title={"Nombre de usuario"} text={nameUser} />
                <InfoUser title={"Matrícula"} text={matricula} />
                {proyectSelected === "66fafd1d92bbc20883798c43" && <InfoUser title={"Fecha"} text={new Date(Fecha_y_hora).toLocaleDateString('es-ES', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                })} />}
                <InfoUser title={"Grupo"} text={grupo ? grupo : "N/A"} />
            </div>
            <div className='w-full h-7/12'>
                <p className='text-[#686868] text-base font-medium py-4'>Historial:</p>
                <CustomTable data={dataFilterPerUser} columns={headers} pageSize={3} />
            </div>
        </div>
    )
}

const InfoUser = ({ title, text }) => {
    return (
        <div className='w-2/6 h-full'>
            <p className='text-[#686868] text-base font-medium'>{title}</p>
            <p className='text-[#454545] text-sm font-normal pt-4'>{text}</p>
        </div>
    )
}

export default TableUserDetails
